<template  >
    <v-layout column fill-height=""> 
        <!-- //access page -->
        <not-access-deny-page 
            v-if="!accessPage"
            :not="not"
            :notShow="true"/> 
        <!-- //page -->
        <v-layout column fill-height v-else> 
            <not-page-spinner 
                :notShow="true" 
                :not="not"
                v-if="!page_show"/> 
            <div v-else class="ma-5 "> 
                
                <!-- toolbar -->
                <v-card class="mt-5 mb-" shaped="" color="accent" v-if="QuestionTimelines" >
                    <v-card-title class="white--text">
                        {{thisOccurrence?thisOccurrence.name:'---'}} 
                    </v-card-title> 
                    <v-tabs
                        v-model="timeline"
                        fixed-tabs   
                        background-color="primary" dark=""
                        >
                        <v-tab v-for="(timeline, index) in ReporterCategoriesData" :key="index">
                            {{timeline.name}} ({{timeline.start_time}} - {{timeline.end_time}})
                        </v-tab>  
                    </v-tabs>
                </v-card> 
    
                <div v-if="accessResponses('read')">
                    <!-- RESULTS GRAPH -->
                    <v-card class="pa-4"  tile="" >
                        <!-- //Show ghp -->
                        <not-page-spinner 
                            :notShow="true" 
                            :not="not"
                            v-if="!page_show_response"/> 
                        <v-row v-else-if="questionTags"> 
                            <v-col sm="6" md="4" cols="12" v-for="(question, index) in questionTags" :key="index" class="pa-1">
                                <v-card  hover="" class="px-2 pt-3" tile="" outlined="" >
                                    <v-layout class="pt-2">
                                        <v-icon class="">mdi-plus-circle-outline</v-icon>
                                        <div class="not-f3 pl-1">{{question.tag}}</div> 
                                    </v-layout>
                                    <!-- <v-layout class="pt-2">
                                        <v-spacer></v-spacer>
                                        <div class="not-f3 pl-1">N = {{question.responses?question.responses.length:0}}</div> 
                                    </v-layout>  -->
                                    <div > 
                                        <div class="py-4" v-if="question.chartType==='pie'"> 
                                            <not-chart-pie
                                                :notShow="true"
                                                :not = "not" 
                                                :notHeight="'300px'"
                                                :notUnit="'Percentage'"
                                                notChartType="question"
                                                :notChartData="question.data"/> 
                                        </div>
                                        <div class="py-4" v-else> 
                                            <not-chart-bar
                                                :notShow="true"
                                                :not = "not" 
                                                :notHeight="'300px'"
                                                :notUnit="'Percentage'"
                                                notChartType="question"
                                                :notChartData="question.data"/> 
                                        </div>
                                        
                                    </div>
                                </v-card> 
    
                            </v-col> 
                        </v-row> 
                        <v-layout v-if="questionTags.length==0" justify-center="" align-center="" class="pa-10 ma-10">
                            <v-icon>warning</v-icon>
                            <div class="not-f7 pl-2">No data found for {{thisOccurrence?thisOccurrence.name:"this"}} Occurrence.</div>
                        </v-layout>  
                    </v-card>  
                </div>
                <div v-else>
                    <v-layout  justify-center="" align-center="" class=" primary lighten-4  pa-9 ">
                        <v-icon size="50" color="primary">mdi-shield-account</v-icon>
                        <div>You do not have permission to read responses.</div> 
                    </v-layout> 
                </div> 
            </div> 
        </v-layout>
    </v-layout>
</template>

<script> 
    import DATA from '../../plugins/DATA'
    import {mapState} from "vuex"
    let pageName = 'Dashboard' 
    let ACTION_TIME = 100
    export default{
        name: pageName,
        props:['not','id'],  
        data: () => ({ 
            page_show: false,  
            page_show_response: false,
            timeline:0,

                
            
        }),  
        created(){
                this.EventBus.$on('notYesDialog', this.notYesDialog); 
        },
        mounted() {   
            this.pageLoad(1000)
        },
        computed:{ 
            accessResponses(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("responses") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("responses") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("responses") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("responses") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                WebReports: state=> state.items[(DATA.ITEMS.WEB_REPORTS.values).toUpperCase()],
                JoinedWebReports: state=> state.join[(DATA.ITEMS.WEB_REPORTS.values).toUpperCase()],
                MobileReports: state=> state.items[(DATA.ITEMS.MOBILE_REPORTS.values).toUpperCase()],
                JoinedMobileReports: state=> state.join[(DATA.ITEMS.MOBILE_REPORTS.values).toUpperCase()],
                Questionnaires: state=> state.items[(DATA.ITEMS.QUESTIONNAIRES.values).toUpperCase()],
                JoinedQuestionnaires: state=> state.join[(DATA.ITEMS.QUESTIONNAIRES.values).toUpperCase()],
                Occurrences: state=> state.items[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()],
                JoinedOccurrences: state=> state.join[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()],
                QuestionTimelines: state=> state.items[(DATA.ITEMS.QUESTION_TIMELINES.values).toUpperCase()],
                JoinedQuestionTimelines: state=> state.join[(DATA.ITEMS.QUESTION_TIMELINES.values).toUpperCase()],
                ReporterCategories: state=> state.items[(DATA.ITEMS.REPORTER_CATEGORIES.values).toUpperCase()],
                JoinedReporterCategories: state=> state.join[(DATA.ITEMS.REPORTER_CATEGORIES.values).toUpperCase()]

            }),  
            ReporterCategoriesData(){
                return this.JoinedReporterCategories?this.JoinedReporterCategories:this.ReporterCategories
            },
            WebReportsData(){ 
                return this.JoinedWebReports?this.JoinedWebReports:this.WebReports
            },
            MobileReportsData(){ 
                return this.JoinedMobileReports?this.JoinedMobileReports:this.MobileReports
            },
            QuestionnairesData(){ 
                return this.JoinedQuestionnaires?this.JoinedQuestionnaires:this.Questionnaires
            },
            OccurrencesData(){ 
                return this.JoinedOccurrences?this.JoinedOccurrences:this.Occurrences
            },
            QuestionTimelines(){ 
                return this.JoinedQuestionTimelines?this.JoinedQuestionTimelines:this.QuestionTimelines
            },
            thisOccurrence(){
                let occurrence_code = this.id
                let occurrences = this.OccurrencesData
                if(!occurrences){return null}
                let filtered = occurrences.find(item=>item.code == occurrence_code) 
                return filtered
            },
            AllReports(){
                let reports = []
                let web = this.WebReportsData
                let mobile = this.MobileReportsData
                if (mobile) {
                    reports.push(...mobile )
                    // reports.push(...web )
                }
                return reports
            },
            
            OccurrenceReports(){
                let occurrence_code = this.id
                let reports = this.AllReports
                if(!reports || !occurrence_code){return null}
                let filtered = reports.filter(rep=>rep.occurrence_code == occurrence_code)
                return filtered
            },


            
            questionTags(){  
                let responses = this.OccurrenceReports
                if(!responses){return []}

                let tags = []
                responses.forEach(element => { 
                    let question = element.question 
                    let tag = question?question.question_tag:null
                    let index = tags.indexOf(tag)

                    if (index==-1) {
                        tags.push(tag)
                    }
                });
                let data =[]
                let NUMBER = 0
                tags.forEach(element => {
                    NUMBER = NUMBER+1
                    let chartData = this.chartData(element)
                    let chartType = ""
                    if (!chartData) {
                            chartType = "bar" 
                        //  console.log("ERROR,,,,-",chartData,"\n EL:"+NUMBER,element,"\n RE:",tags);
                            
                    } else {
                        if (chartData.type ==="yes/no") {
                            chartType = "pie" 
                        }else if (chartData.type ==="gender") {
                            chartType = "pie" 
                        }else if (chartData.type ==="time") {
                            chartType = "pie" 
                        }else if (chartData.type ==="multiple choice") {
                            chartType = "pie" 
                        }else{
                            chartType = "bar"   
                        }
                    }
                    data.push({
                        ...chartData,
                        tag:element,
                        chartType:chartType
                    })
                    
                }); 
                return data
            },

            flaggedQuestion(){
                let responses = this.OccurrenceReports
                if(!responses){return null}
                let ft = responses.filter(res=>{
                    return res.flagged == true
                })
                return ft
            }

                
        },
        //------------methods---------------
        methods: {  
            clicked(){ 
            }, 
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+'=ADD-RESULT') {
                            
                    }  
                    
                }
            }, 

            //Chart
            tagFilter(tag){
                // let responses = this.Filted_questionResponse 
                let responses = this.MobileReportsData 
                if(!responses){return null}
                if(!tag){return null}
                
                let tag_responses = responses.filter(res=>{
                    let question = res.question?res.question:null
                    let question_tag = question?question.question_tag:null
                    return question_tag==tag
                })

                return tag_responses
            },
            chartData(tag){
                // return {}
                let responses = this.tagFilter(tag) 
                if(!responses){return null}
                let q1 = responses[0] 
                let type = q1?q1.question_type_name:"number"

                let data = []
                if (type === "yes/no") {
                    data = this.calculate_yesOrNo(responses)
                }else if (type === "gender") {
                    data = this.calculate_gender(responses)
                }else if (type === "number") {
                    data = this.calculate_number(responses) 
                }else if (type === "time") {
                    data = this.calculate_time(responses) 
                }else if (type === "multiple choice") {
                    data = this.calculate_multiple_choice(responses) 
                }else {
                    data = this.calculate_number(responses) 
                } 
                
                let chart = {
                    type:type,
                    data:data,
                    responses:responses
                }
                console.log(chart,'ch........v');
                console.log(type,'type........v');
                return chart
            },
            
            //calculate
            calculate_yesOrNo(responses){
                if(!responses){return null}
                //get answers
                let ANSWERS = []
                responses.forEach(element => {
                    let question_number = element.question_number
                    let question_answer = element.question_answer_only
                    ANSWERS.push(question_answer)  
                });
                //calculate answers
                let yes = 0
                let no = 0
                ANSWERS.forEach(ans => {
                    let answer = ans*1
                    if (answer===1) {
                        yes = yes+1
                    }else{
                        no = no+1
                    }
                });

                // create data
                let data = []
                data.push({
                    name:"Yes",
                    value:yes
                })
                data.push({
                    name:"No",
                    value:no
                })  
                    

                return  data

            },
            calculate_gender(responses){
                console.log(responses,'responses.......');
                if(!responses){return null}
                //get answers
                let ANSWERS = []
                responses.forEach(element => {
                    let question_number = element.question_number
                    let question_answer = element.question_answer_only 
                    ANSWERS.push(question_answer) 
                    
                });
                //calculate answers
                let male = 0
                let female = 0
                ANSWERS.forEach(ans => {
                    if(!ans){return}
                    let aVaues = ans.split(";")
                    let m = (aVaues[0])*1
                    let f= (aVaues[1])*1 
                    male = male+m
                    female = female+f
                });

                // create data
                let data = []
                data.push({
                    name:"Male",
                    value:male
                })
                data.push({
                    name:"Female",
                    value:female
                })  
                console.log(data,'g......');
                    

                return  data

            },
            calculate_multiple_choice(responses){
                if(!responses){return null}
                //get pre_ans 
                let question_predefined_answer = responses[0].question_predefined_answer
                let pre_answers = []
                if (question_predefined_answer) {
                    pre_answers = question_predefined_answer.split(",")
                }
                let getPreAnswer=(index)=>{
                    index = (index*1)-1
                    let p = pre_answers[index]
                    if (!p) {
                        return "0"
                    }
                    return p
                }
                //get answers
                let ANSWERS = []
                //
                pre_answers.forEach(element => {
                    ANSWERS[element]=0
                });
                responses.forEach(element => {
                    let question_number = element.question_number
                    let question_answer = element.question_answer_only 
                    if (!question_answer) {
                        question_answer=question_number 
                    } 
                    let p = getPreAnswer(question_answer)
                    ANSWERS[p] = (ANSWERS[p]*1)+1 
                });

                //create data
                let data = []
                pre_answers.forEach(element => {
                    data.push({
                        name:element,
                        value:ANSWERS[element]
                    }) 
                });  
                return  data

            },
            calculate_time(responses){
                if(!responses){return null}
                //compire time
                let checkTime = (time)=>{
                    let current_timeline = this.OccurrenceReports
                    if(!current_timeline){return null}
                    let start_time = current_timeline.start_time
                    if(!start_time){return null}
                    if(!time){return null}

                    let date = '01/01/2020 '
                    let s_time = time.split(":")
                    let s_start_time= start_time.split(":")

                    //check length
                    if (s_time.length ===2) {
                        time = time+":00"
                    }
                    if (s_start_time.length ===2) {
                        start_time = start_time+":00"
                    }
                    time=date+time
                    start_time =date+start_time
                    
                    //compare
                    let time1 =Date.parse(time)
                    let time2 = Date.parse(start_time)
    
                    let onTime = time1>=time2
                    return onTime
                }
                //get answers
                let ANSWERS = []
                let ONTIME = 0
                let LATE  =0
                responses.forEach(element => {
                    let question_number = element.question_number
                    let question_answer = element.question_answer_only
    
                    let onTime = checkTime(question_answer) 
                    if (onTime!=null) {
                        if (onTime) {
                            ONTIME = ONTIME +1
                        }else{
                            LATE = LATE +1
                        }
                    }   
                });

                    
                // create data
                let data = []
                data.push({
                    name:"On time",
                    value:ONTIME
                })
                data.push({
                    name:"Late",
                    value:LATE
                })   
                return  data

            },
            calculate_number(responses){
                if(!responses){return null}
                //get Numbers
                let Q_NUMBER = []
                responses.forEach(element => { 
                    let q_number = element.question_number
                    let index = Q_NUMBER.indexOf(q_number)

                    if (index==-1) {
                        Q_NUMBER.push(q_number)
                    }

                });

                let average = (q_number)=>{
                    let number = 0
                    let total = 0
                    responses.forEach(element => {
                        let question_number = element.question_number
                        if (question_number===q_number) {
                            let question_answer = element.question_answer_only 
                            let value = question_answer*1  
                            number = number+1
                            total = total+value 
                        } 
                    });  
                    return total/number
                }
                
                //find lable
                let lable =(q_number)=>{
                    let tag_value = ''
                    responses.forEach(element => {
                        let question_number = element.question_number
                        if (question_number === q_number) {
                            let question_tag_value = element.question_tag_value
                            tag_value = question_tag_value
                        }
                    });

                    return tag_value ===""?q_number:tag_value
                }


                // create data
                let data = []
                Q_NUMBER.forEach(element => {
                    data.push({
                        name:lable(element),
                        value:average(element)
                    })
                });

                console.log(responses,data,'number data.....'); 
                return  data

            },

            


            //-----------------[PAGE CONTRAL]---------
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting_responses = ps.find(process=>{
                            return process.name == 'getting/questionResponses'
                        })
                        let getting_timelines = ps.find(process=>{
                            return process.name == 'getting/questionTimelines'
                        })
                            

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting_responses) {
                            this.page_show_response =false
                            this.not.notDialogP(true,false,'Loading...')
                        }else{ 
                            this.page_show_response =true
                        } 


                            
                        //IF ALL DONE
                        if (ps.length===0) { 
                            this.page_show = true
                            this.not.notDialogP(false)
                        }
                    }else{
                        this.page_show = true
                        this.not.notDialogP(false)
                    }

                    //check response
                    if (res.res==='adding/results/successful') { 
                        this.not.notDialog(true,true,'Successful','Result successfully added.','','OK',{code:pageName+'=ADD-RESULTS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='adding/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding the result. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=ADD-RESULTS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }  
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
     
    